var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-tooltip-btn',{attrs:{"href":"https://store.vuetifyjs.com/?utm_source=vuetifyjs.com&utm_medium=toolbar","icon":"$mdiShoppingOutline","path":"store","rel":"noopener","target":"_blank"},on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }